import store from './store'
import Api from "./services/api_endpoints";

export default {
    async login (email, password) {
        try {
            if (this.getToken()) {
                return true
            }
            const response = await Api.login(email, password)

            if (response.data.hasOwnProperty('data') && response.data.data.hasOwnProperty('token')) {
                this.saveToken(response.data.data.token)
                return true
            }
        } catch (e) {
            return false
        }

        return false
    },

    getToken () {
        if (store.state.token == null) {
            const fromCookie = window.$cookies.get('token')
            if (fromCookie != null) {
                this.saveToken(fromCookie)
            }
        }

        return store.state.token
    },

    logout () {
        // committing 'reset' will remove the token from 'store',
        // but we need to explicitly commit a null value to it so
        // the right mutation is called that removes the cookie as well
        this.saveToken(null)
        store.commit('reset')
    },

    saveToken(value) {
        store.commit('setToken', value)
    },

    loggedIn () {
        return !!this.getToken()
    },

    onChange () {}
}
